export default __webpack_public_path__ + "static/media/ai_virtual_services_price_fr.260fb332.png";